export default __webpack_public_path__ + "static/media/bg1.0538a4b4.jpg";